import React, {useContext, useEffect, useRef} from 'react';
import LogoutContext from '../context/LogoutContext';
import {Badge} from 'primereact/badge';
import ReminderComponent from '../components/ReminderComponent';
import { MenuItem } from 'react-pro-sidebar';
import { FaUser } from 'react-icons/fa';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { useHistory } from 'react-router-dom';

export const HeaderComponent = ({reminders, getReminders}) => {
    const handleLogoutUser = useContext(LogoutContext);
    const reminderRef = useRef({});
    const handleLogout = () => {
        handleLogoutUser();
    };

    useEffect(() => {
        return () => {};
    }, []);
    const history = useHistory();
    return (
        <div id='main-header'>
            <div className='container-fluid'>
                <div className='col-12'>
                    <div id='header-buttons' style={{marginRight: '0px'}}>
                    <i
                            id="profileButton"
                            className="mdi mdi-account cursor-pointer"
                            onClick={() => history.push('/manage-account/details')}
                            style={{ fontSize: '28px', color: '#1e325c', marginTop: '20px' }}
                        />
                        <i
                            className='mdi mdi-bell-outline cursor-pointer reminder '
                            onClick={(e) => {
                                reminderRef.current.toggle(e);
                            }}
                            style={{fontSize: '25px', color: '#1e325c', marginTop: '20px'}}
                        >
                            {reminders?.content.length !== 0 && (
                                <Badge value={reminders?.totalElements} severity={'warning'}></Badge>
                            )}
                        </i>
                        <i
                            id='logoutButton'
                            className='mdi mdi-logout cursor-pointer'
                            onClick={handleLogout}
                            style={{fontSize: '25px', color: 'red', marginTop: '20px'}}
                        />
                        <ReminderComponent reminderRef={reminderRef} reminders={reminders?.content} rendered={true} refresh={() => getReminders()} />
                    </div>
                </div>
            </div>
        </div>
    );
};
